import Header from './Templates/Header';
import Footer from './Templates/Footer';
import { Outlet } from "react-router";
const MainLayout = () => {
    return(
        <>
        <Header/>
        <Outlet />
        <Footer />
        </>
    )
}
export default MainLayout;